/**
 * 从 UserRewardItem.extra（JSON字符串）中解析出 FreeOrderCardExtra
 */
export function parseFreeOrderCardExtra(item) {
    try {
        if (!item?.extra)
            return null;
        const parsed = JSON.parse(item.extra);
        return parsed?.freeOrderCardExtra ?? null;
    }
    catch {
        return null;
    }
}
